import { render, staticRenderFns } from "./ConsultTicket.vue?vue&type=template&id=9cdb27fa&scoped=true"
import script from "./ConsultTicket.vue?vue&type=script&lang=js"
export * from "./ConsultTicket.vue?vue&type=script&lang=js"
import style0 from "./ConsultTicket.vue?vue&type=style&index=0&id=9cdb27fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cdb27fa",
  null
  
)

export default component.exports